module.exports = __webpack_public_path__ + "img/Flag_of_India.f3a60ba3.svg";